import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

import LumeraLogoSVG from '@itm/shared-frontend/lib/assets/images/lumera-logo.svg?url';

export const tenantSliceSelector = (state: RootState) => state.tenant;

export const tenantBrandingSelector = createSelector(tenantSliceSelector, (state) => state.branding);

export const tenantBrandingNameSelector = createSelector(
  tenantBrandingSelector,
  (state) => state?.name || 'Lumera DataHub',
);
export const tenantBrandingLogoAltSelector = createSelector(tenantBrandingNameSelector, (state) => `${state} logo`);
export const tenantBrandingLogoUrlSelector = createSelector(
  tenantBrandingSelector,
  (state) => state?.logoUrl || LumeraLogoSVG,
);

export const tenantBrandingTermsAndConditionsSelector = createSelector(
  tenantBrandingSelector,
  (state) => state?.termsAndConditions || '',
);

export const tenantIdSelector = createSelector(tenantBrandingSelector, (branding) =>
  branding ? branding.tenantId : null,
);

export const tenantListSelector = createSelector(tenantSliceSelector, (state) => state.tenantList);

export const tenantListDataSelector = createSelector(tenantListSelector, (state) => state.data);

export const tenantListIsLoadingSelector = createSelector(tenantListSelector, (state) => state.isLoading);

export const tenantListServerErrorsSelector = createSelector(tenantListSelector, (state) => state.serverErrors);

export const tenantListOptionsSelector = createSelector(tenantListDataSelector, (data) =>
  data.map(({ id, name }) => ({ value: id, label: name || id })).sort((a, b) => a.label.localeCompare(b.label)),
);
